import React from "react";

import StyledScrollbar from "../../../Common/UIComponents/StyledScrollbar";
import FormLayout from "../../../Onboarding/FormLayout";
import "./OnboardingFormLayout.css";

export default function OnboardingFormLayout({ children }) {
  return (
    <FormLayout className="OnboardingFormLayout__SampleSubmission">
      <StyledScrollbar
        id="OnboardingscrollBar"
        className="Onboarding__Scrollbar"
      >
        {children}
      </StyledScrollbar>
    </FormLayout>
  );
}
